import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="text-center mb-5">
        <Col>
          <h1 className="display-4">Welcome to MainDraw</h1>
          <h2 className="lead fw-bold text-primary mb-2">
            Smarter planning. Stronger results.
          </h2>
          <p className="lead">
            Master the Draw Before the Match
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={5}>
          <Card className="mb-4 shadow-sm">
            <Card.Body className="text-center p-5">
              <h2>Players</h2>
              <p>
                Search for players, view their details, and track their rankings over time.
              </p>
              <Link to="/players">
                <Button variant="primary">Search Players</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5}>
          <Card className="mb-4 shadow-sm">
            <Card.Body className="text-center p-5">
              <h2>Tournaments</h2>
              <p>
                Create and manage tournaments, add players, and organize competitions.
              </p>
              <Link to="/tournaments">
                <Button variant="primary">View Tournaments</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default HomePage;
